import axios from 'axios'

var qs = require('qs');
var root = window.API_ROOT



//获取列表数据
export const inventorySave = (params) => {
  return axios.post(root + '/warehouse/jxcstoreform/inventorySave', qs.stringify(params))
}

//获取列表数据
export const machiningBaosun = (params) => {
  return axios.post(root + '/warehouse/jxcstoreform/machiningBaosun', qs.stringify(params))
}

//获取列表数据
export const machiningBaosunList = (params) => {
  return axios.post(root + '/warehouse/jxcstoreform/machiningBaosunList', qs.stringify(params))
}

export const getByERPSerial = (params) => {
  return axios.post(root + '/warehouse/jxcstoreform/getByERPSerial', qs.stringify(params))
}

export const removeByERPSerial = (params) => {
  return axios.post(root + '/warehouse/jxcstoreform/removeByERPSerial', qs.stringify(params))
}



// WEBPACK FOOTER //
// ./src/api/set/jxcstoreform.js